import { useTypedSelector } from "hooks";
import { WebRoutes } from "consts/enpoints/web";
import { convertToBooleanSwitch } from "util/transformers";
import { formatDate, UiDateTimeFormatter } from "util/formaters";
import { HighRiskMerchant as HighRiskMerchantApi } from "features/ecommerce/api";
import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { selectOnboardingLegalForms } from "features/general/selectors";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingForm, useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useBusinessInformation = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingBusinessInformation>();

    const withValues = useOnboardingForm({
        save: HighRiskMerchantApi.putOnboardingsHighRiskBusinessInformationSteps,
        route: WebRoutes.Onboarding.HighRiskMerchant,
        getApplicationModel
    });

    const formProps: HighRiskMerchant.BusinessInformation.OnboardingBusinessInformationForm = {
        bootstrapData: {
            entityType: useTypedSelector(selectOnboardingLegalForms)
        },
        initialValues: HighRiskMerchant.BusinessInformation.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: ({
            legalNameOfBusiness,
            tradeName,
            mailingAddress,
            entityType,
            yearsUnderOwnership,
            incorporationId,
            country,
            countryOfIncorporation,
            incorporationDate,
            companyAddress,
            city,
            postalCode,
            contactName,
            contactEmail,
            contactPhone,
            techContactName,
            techContactEmail,
            techContactPhone,
            finContactName,
            finContactEmail,
            finContactPhone,
            emergencyContactName,
            emergencyContactEmail,
            emergencyContactPhone,
            wishDirectIntegration,
            wishDirectIntegrationInput,
            integrationContactEmail
        }, helpers) => (
            withValues({
                legalNameOfBusiness,
                tradeName,
                mailingAddress,
                country: country![0],
                countryOfIncorporation: countryOfIncorporation![0],
                incorporationDate: formatDate(incorporationDate, {
                    pattern: UiDateTimeFormatter.Ui
                }),
                entityType: String(entityType),
                yearsUnderOwnership: String(yearsUnderOwnership),
                incorporationId,
                companyAddress,
                city,
                postalCode,
                contactName,
                contactEmail,
                contactPhone,
                techContactName,
                techContactEmail,
                techContactPhone,
                finContactName,
                finContactEmail,
                finContactPhone,
                emergencyContactName,
                emergencyContactEmail,
                emergencyContactPhone,
                wishDirectIntegration: convertToBooleanSwitch(wishDirectIntegration),
                wishDirectIntegrationInput,
                integrationContactEmail
            }, helpers)
        )
    };

    return {
        ...formProps,
        ...HighRiskMerchant.BusinessInformation.useForm(formProps),
        ...data
    };
};

export default useBusinessInformation;
